import { format, utcToZonedTime } from 'date-fns-tz';

import { type AgendaTemplateTopic, type Meeting, type MeetingTime } from '@meetings/details/types';

type EnrichedAgendaTemplateTopic = {
    name: string;
    topics: EnrichedAgendaTemplateTopic[];
    category: number;
};

const getZonedDate = (value: string, timeZone: string): string => {
    const zoned = utcToZonedTime(new Date(value), timeZone);
    return format(zoned, "yyyy-MM-dd'T'HH:mm");
};

const getZonedTime = (value: string, timeZone: string): string => {
    const zoned = getZonedDate(value, timeZone);
    return zoned.split('T')[1];
};

export const enrichTemplateTreeWithCategory = (
    templateTopics: AgendaTemplateTopic[],
    category: number
): EnrichedAgendaTemplateTopic[] =>
    templateTopics.map(({ name, topics }) => ({
        name,
        category,
        topics: topics.length ? enrichTemplateTreeWithCategory(topics, category) : []
    }));

export const replaceTopicsWithChildren = (items: EnrichedAgendaTemplateTopic[]) => {
    return items.reduce(
        (acc: EnrichedAgendaTemplateTopic[], currentItem: EnrichedAgendaTemplateTopic) => {
            const newItem: any = { ...currentItem };

            newItem.children = newItem.topics;

            delete newItem.topics;

            if (newItem.children && newItem.children.length > 0) {
                newItem.children = replaceTopicsWithChildren(newItem.children);
            }

            acc.push(newItem);

            return acc;
        },
        []
    );
};

export const appendZonedTimes = (details: Meeting): Meeting & MeetingTime => {
    const time: Partial<Meeting & MeetingTime> = {};
    if (details.deadline) {
        time.deadline = getZonedDate(details.deadline, details.timezone);
        time.deadlineUTC = details.deadline;
    }
    if (details.end) {
        time.end = getZonedDate(details.end, details.timezone);
        time.endTime = getZonedTime(details.end, details.timezone);
        time.endUTC = details.end;
    }
    if (details.start) {
        time.start = getZonedDate(details.start, details.timezone);
        time.startTime = getZonedTime(details.start, details.timezone);
        time.startUTC = details.start;
    }
    return {
        ...details,
        ...time
    };
};
